export const partnersCarouselSettings = {
  dots: true,
  customPaging: (i: number) => (
    <div
      // style={{
      //   position: 'absolute',
      //   width: '100%',
      //   top: '-6px',
      //   opacity: '0',
      // }}
      className="partners-carousel-dots"
    >
      {i + 1}
    </div>
  ),
  dotsClass: 'partner-dot',
  mobileFirst: true,
  infinite: false,
  speed: 1000,
  autoplaySpeed: 2000,
  slidesToShow: 4.2,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: false,
  autoplay: false,
  swipeToSlide: true,
  pauseOnHover: true,
  focusOnSelect: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.0,
        slidesToScroll: 1,
        initialSlide: 2,
        infinite: false,
        dots: true,
      },
    },

    {
      breakpoint: 600,
      settings: {
        initialSlide: 1,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.0,
        slidesToScroll: 1,
        initialSlide: 2,
        infinite: false,
        dots: true,
      },
    },
  ],
};
